import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  Box,
} from "@mui/material";
import { Warning } from "@mui/icons-material";
import { Coach } from "../types/Coach";

interface DeleteCoachDialogProps {
  open: boolean;
  onClose: () => void;
  coach: Coach | null;
  onConfirm: () => void;
  loading: boolean;
}

const DeleteCoachDialog: React.FC<DeleteCoachDialogProps> = ({
  open,
  onClose,
  coach,
  onConfirm,
  loading,
}) => {
  if (!coach) return null;

  return (
    <Dialog
      open={open}
      onClose={!loading ? onClose : undefined}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ pb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Warning sx={{ color: "error.main" }} />
          <Typography variant="h6" component="div" sx={{ fontWeight: "bold" }}>
            Confirmer la suppression
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2, borderRadius: 2 }}>
          Cette action est irréversible. L'entraîneur sera définitivement
          supprimé.
        </Alert>

        <Typography variant="body1" sx={{ mb: 2 }}>
          Êtes-vous sûr de vouloir supprimer cet entraîneur ?
        </Typography>

        <Box
          sx={{
            backgroundColor: "#f8f9fa",
            p: 2,
            borderRadius: 2,
            border: "1px solid #dee2e6",
            mb: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary" gutterBottom>
            <strong>Nom:</strong> {coach.name}
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            <strong>Email:</strong> {coach.mail}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>Téléphone:</strong> {coach.number}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          disabled={loading}
          color="inherit"
          variant="outlined"
        >
          Annuler
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          color="error"
          variant="contained"
          sx={{
            background: "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)",
            "&:hover": {
              background: "linear-gradient(135deg, #d32f2f 0%, #c62828 100%)",
            },
          }}
        >
          {loading ? "Suppression..." : "Supprimer"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCoachDialog;
